import React from 'react';
import { GlassCard } from '../../../_shared/GlassCard';
import { Layers, Zap, Video, ArrowRight } from 'lucide-react';
import { PHASE2, formatNum } from '../data';

const icons = [Layers, Zap, Video];
const iconColors = ['bg-purple-500/20 text-purple-300', 'bg-amber-500/20 text-amber-300', 'bg-pink-500/20 text-pink-300'];

export const NextPhase = () => {
    const vm = PHASE2.volumeMath;
    return (
        <section className="py-16 px-4 pb-28">
            <div className="container mx-auto max-w-6xl">
                <p className="text-white/40 text-xs uppercase tracking-[0.2em] font-semibold text-center mb-3">What's Next</p>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-center">
                    Phase 2 — Open The Throttle
                </h2>
                <p className="text-white/50 text-center mb-12 max-w-2xl mx-auto">
                    The hard part is done: the personas are proven, the pipeline is warm, and a 90-episode
                    backlog is sitting ready. Phase 2 is pure multiplication.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
                    {PHASE2.pillars.map((p, i) => {
                        const Icon = icons[i % icons.length];
                        return (
                            <GlassCard key={i}>
                                <div className={`${iconColors[i % iconColors.length]} p-3 rounded-xl mb-4 inline-flex`}>
                                    <Icon size={22} />
                                </div>
                                <p className="text-white font-bold text-lg mb-2 tracking-tight">{p.title}</p>
                                <p className="text-white/50 text-sm leading-relaxed">{p.body}</p>
                            </GlassCard>
                        );
                    })}
                </div>

                <GlassCard>
                    <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12 py-2">
                        <div className="text-center">
                            <p className="text-white/40 text-[10px] uppercase tracking-widest font-semibold mb-1">Today's Volume</p>
                            <p className="text-3xl md:text-4xl font-black text-white tracking-tight">{formatNum(vm.currentPostsPerMonth)}</p>
                            <p className="text-white/40 text-xs mt-1">posts / month</p>
                        </div>
                        <ArrowRight className="text-purple-300 rotate-90 md:rotate-0" size={28} />
                        <div className="text-center">
                            <p className="text-purple-300 text-[10px] uppercase tracking-widest font-semibold mb-1">Phase 2 Volume</p>
                            <p className="text-3xl md:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-purple-300 to-blue-300 tracking-tight">{formatNum(vm.phase2PostsPerMonth)}+</p>
                            <p className="text-white/40 text-xs mt-1">posts / month (projected)</p>
                        </div>
                    </div>
                    <p className="text-white/40 text-xs text-center mt-4 max-w-2xl mx-auto">{vm.note}</p>
                </GlassCard>
            </div>
        </section>
    );
};
